import { render, staticRenderFns } from "./ImpactOfDisabilityResults.vue?vue&type=template&id=7f0ac2e6&scoped=true"
import script from "./ImpactOfDisabilityResults.vue?vue&type=script&lang=js"
export * from "./ImpactOfDisabilityResults.vue?vue&type=script&lang=js"
import style0 from "./ImpactOfDisabilityResults.vue?vue&type=style&index=0&id=7f0ac2e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0ac2e6",
  null
  
)

export default component.exports